import Vue     from 'vue'

Vue.directive('cursor', {
  bind: function (el) {
    el.style.cursor = "pointer";
  }
})